import {useEffect, useState} from 'react';
import {getApi} from "../../apis/backendApis";

/**
 * Quem pode ocupar os papeis de um fluxo (#484909): os usuarios ativos dos
 * setores do fluxo. Sem setor no fluxo, todos os ativos ("restrito" falso).
 */
export interface PessoasPapel {
    setores: Array<{id: number, nome: string}>,
    usuarios: Array<{id: number, nome: string}>,
    restrito: boolean,
}

export const buscaPessoasPapel = (filtro: {fluxo_id?: number, processo_id?: number}): Promise<PessoasPapel> =>
    getApi().get('processo/pessoas-papel', {params: filtro}).then(r => r.data as PessoasPapel);

/**
 * Busca pelo fluxo (abertura) ou pelo processo. undefined enquanto carrega;
 * null sem filtro ou se a busca falhar (a tela cai na lista de todos e a API confere).
 */
export const usePessoasPapel = (filtro: {fluxo_id?: number, processo_id?: number}): PessoasPapel | null | undefined => {
    const [pessoas, setPessoas] = useState<PessoasPapel | null | undefined>(undefined);
    useEffect(() => {
        if (!filtro.fluxo_id && !filtro.processo_id) {
            setPessoas(null);
            return;
        }
        setPessoas(undefined);
        let vivo = true;
        buscaPessoasPapel(filtro).then(dados => vivo && setPessoas(dados)).catch(() => vivo && setPessoas(null));
        return () => { vivo = false; };
    }, [filtro.fluxo_id, filtro.processo_id]);
    return pessoas;
};

/** Opcoes de pessoa: as do fluxo; nenhuma enquanto carrega; todas se nao deu para saber. */
export const opcoesDePessoas = (pessoas: PessoasPapel | null | undefined, todos: Array<{id: number, nome: string}>) =>
    pessoas === undefined ? [] : (pessoas ? pessoas.usuarios : todos);

/** "Pessoas dos setores Fiscal e Financeiro" (para a ajuda abaixo da escolha). */
export const textoSetores = (pessoas: PessoasPapel | null | undefined) => {
    if (!pessoas?.restrito) return '';
    const nomes = pessoas.setores.map(s => s.nome);
    const lista = nomes.length > 1 ? `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}` : nomes[0];
    return `Só pessoas ${nomes.length > 1 ? 'dos setores' : 'do setor'} ${lista} (setores do fluxo).`;
};
